class PredictiveSearch extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector("#predictive-search");
		this.filter = document.querySelector(".mm-filter-mega-menu");
    this.header = this.closest(".mm-header");
    this.headerBottom = this.header.querySelector(".mm-header-bottom");
	  this.headerIcons = this.header.querySelector(".mm-header-icons");

		this.handleFocus = this.handleFocus.bind(this);
		this.outsideClickHandler = this.outsideClickHandler.bind(this);

		// Ouvrir la recherche prédictive et appeler onChange dès le clic/focus
		this.input.addEventListener("focus", this.handleFocus);

    document.addEventListener('click', this.outsideClickHandler);

    this.predictiveSearchResults.addEventListener('click', (event) => {
      const target = event.target.closest('a, button');

      if (!target) return;

      if (target.tagName === 'A') {
        this.close();
      } else if (target.tagName === 'BUTTON') {
        const form = this.input.closest('form');
        if (form) {
          form.submit();
        }
      }
    });

		this.input.addEventListener(
			"input",
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

	handleFocus() {
		this.open();
		this.getSearchResults("_");

		// Cache .mm-header-bottom
		if (this.headerBottom) {
			this.headerBottom.style.display = "none";
		}
	}

	outsideClickHandler(event) {
		if (this.predictiveSearchResults.style.display === 'block' && !this.contains(event.target)) {
			this.close();
		}
	}

	onChange() {
		const searchTerm = this.input.value
			.trim()
			.toLowerCase()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "");

		// if (!searchTerm.length) {
		// 	this.close();
		// 	return;
		// }
    // if (!searchTerm.length || searchTerm === "_") {
    //   this.productsContainer.style.display = "none"; // Cachez le conteneur des produits
	  // }

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm = "_") {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
				console.log("response", response);
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();

				// Si le searchTerm est vide ou égal à "_", cachez également le productsContainer
        console.log('searchTerm', searchTerm);

        this.productsContainer = this.querySelector(".mm-psearch-products");


				if (searchTerm === "_" || searchTerm.length === 0) {
          this.predictiveSearchResults.classList.add('no-products-mobile');
          console.log("this.predictiveSearchResults add", this.predictiveSearchResults);
				} else {
					this.predictiveSearchResults.classList.remove('no-products-mobile');
          console.log("this.predictiveSearchResults remove", this.predictiveSearchResults);

				}
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}

	open() {
    this.input.removeEventListener("focus", this.handleFocus);
		this.predictiveSearchResults.style.display = "block";
		showBgFilter();


		// if (this.filter) {
		// 	this.filter.addEventListener("click", this.close.bind(this));
    //   console.log('open filter', this.filter);
		// }
	}

	close() {
    this.predictiveSearchResults.style.display = "none";
    console.log(this.predictiveSearchResults);
	hideBgFilter();

	    // Affiche à nouveau .mm-header-bottom
		if (this.headerBottom) {
			this.headerBottom.style.display = "block";
		}

    setTimeout(() => {
		this.input.addEventListener("focus", this.handleFocus);
    }, 500);
	}



	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

customElements.define("predictive-search", PredictiveSearch);

// Table correspondance
function setUpSearchForm() {
    // Trouver le formulaire de recherche
    const searchForm = document.querySelector('predictive-search form');
    if (!searchForm) {
        console.log('Formulaire de recherche non trouvé');
        return;
    }

  console.log('searchForm in setUpSearchForm', searchForm)

    // Fonction de gestion de la soumission
    const handleSubmit = (event) => {
        // Récupérer la valeur de recherche
        const searchInput = searchForm.querySelector('input[type="search"]');
        if (!searchInput) {
            console.log('Input de recherche non trouvé');
            return;
        }
        
        const searchTerm = searchInput.value
			.trim()
			.toLowerCase()
			.normalize("NFD")
            .replace("'", " ")
            .replace("’", " ")
			.replace(/[\u0300-\u036f]/g, "");
        //console.log('Terme de recherche:', searchTerm);
        
        // Récupérer tous les inputs de correspondance
        const correspondenceInputs = document.querySelectorAll('.mm-search-table-input');
        //console.log('Nombre d\'inputs de correspondance trouvés:', correspondenceInputs.length);
        
        // Vérifier chaque correspondance
        for (const input of correspondenceInputs) {
            try {
                const termes = JSON.parse(input.dataset.termes);
                //console.log('Termes de correspondance:', termes);
                
                // Vérifier si le terme de recherche correspond à l'un des termes
                if (
                    termes.some(
                        terme =>
                            searchTerm === terme.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim()
                    )
                ) {
                    //console.log('Correspondance trouvée! Redirection vers:', input.value);
                    // Si correspondance trouvée, empêcher le comportement par défaut
                    // Rediriger vers l'URL correspondante
                    event.preventDefault();
                    window.location.href = input.value;
                    return;
                }
            } catch (error) {
                console.error('Erreur lors du parsing des termes:', error);
            }
        }
        
        console.log('Aucune correspondance trouvée, soumission normale du formulaire');
    };

    // Supprimer l'ancien écouteur d'événement s'il existe
    searchForm.removeEventListener('submit', handleSubmit);
    // Ajouter le nouvel écouteur d'événement
    searchForm.addEventListener('submit', handleSubmit);
}

// S'assurer que le DOM est chargé avant d'initialiser
document.addEventListener('DOMContentLoaded', setUpSearchForm);

// Réinitialiser l'écouteur d'événement après chaque navigation
window.addEventListener('pageshow', (event) => {
    setUpSearchForm();
});

// Réinitialiser l'écouteur d'événement après chaque changement de page
document.addEventListener('shopify:section:load', setUpSearchForm);